import React from 'react';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';
import { Card } from '@wds/card';
import { T, defineMessages } from '@sm/intl';
import useStyles from './useStyles';

const COPY = defineMessages({
  SORRY_MESSAGE: {
    id: 'FourOhFourError.sorryMessage',
    defaultMessage: "We're sorry",
    description: '[Type: Label][Vis.: med] - We are sorry message',
  },
  CANT_FIND_PAGE: {
    id: 'FourOhFourError.cantFindPage',
    defaultMessage: "We can't find the page you're looking for.",
    description: '[Type: Label][Vis.: med] - Cant find page message',
  },
  CHECK_URL: {
    id: 'FourOhFourError.checkURL',
    defaultMessage:
      "Please check the URL you entered to make sure it's spelled correctly.",
    description: '[Type: Label][Vis.: med] - check URL subtitle',
  },
  HELP_FIND_WAY: {
    id: 'FourOhFourError.helpFindWay',
    defaultMessage:
      'Still not sure how to get to the page you want? Maybe we can help you find your way:',
    description: '[Type: Label][Vis.: med] - Help find your way subtitle',
  },
  SIGN_UP_FREE: {
    id: 'FourOhFourError.signUpFree',
    defaultMessage: 'Sign Up FREE',
    description: '[Type: Label][Vis.: med] - Sign up free button',
  },
});

const FourOhFourError = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} data-testid="FourOhFourError">
      <div className={classes.messageWrapper}>
        <Typography variant="pageTitle" align="center">
          <T desc={COPY.SORRY_MESSAGE} />
        </Typography>
        <div className={classes.cardWrapper}>
          <Card p={2}>
            <div className="wds-p-1">
              <Typography
                component="section"
                variant="sectionTitle"
                align="center"
              >
                <T desc={COPY.CANT_FIND_PAGE} />
              </Typography>
            </div>
            <div className="wds-p-1">
              <Typography component="div" variant="body" align="center">
                <p>
                  <T desc={COPY.CHECK_URL} />
                </p>
                <p>
                  <T desc={COPY.HELP_FIND_WAY} />
                </p>
              </Typography>
            </div>

            <div className="wds-p-1">
              <Typography component="div" variant="cardTitle" align="center">
                Want to create your own survey?
              </Typography>
            </div>

            <Button
              color="upgrade"
              href="/user/sign-up/?ut_source=404_page"
              label=""
            >
              <T desc={COPY.SIGN_UP_FREE} />
            </Button>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default FourOhFourError;
